import React, { useCallback } from "react";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import CustomMenu from "../../../../components/Menu";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";
import { userTypes } from "../../../../utils/constants/index.js";
import { FilterOptionsList } from "../../../../components/FilterOptionsList.js";
import { DownArrowIcon } from "../../../../components/DownArrowIcon.js";

function FilterUserType() {
  const [userTypeMenu, setUserTypeMenu] = React.useState(null);
  const [userFilter, updateParams, removeSearchParam] =
    useCustomSearchParams("users-type");
  const isMobile = useResponsive("down", "md");

  const handleClick = useCallback((event) => {
    setUserTypeMenu(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setUserTypeMenu(null);
  }, []);

  const openUserTypeMenu = Boolean(userTypeMenu);

  return (
    <div className="mr-2">
      {isMobile ? (
        <FilterOptionsList
          options={userTypes}
          paramsKey={"users-type"}
          filterType={userFilter}
        />
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          className="filter-btn white-button"
          onClick={handleClick}
          endIcon={<DownArrowIcon/>}
        >
          <p className="capitalize">{userFilter || "User Type"}</p>
        </CustomButton>
      )}
      <CustomMenu
        open={openUserTypeMenu}
        handleClose={handleClose}
        anchorEl={userTypeMenu}
      >
        <FilterOptionsList
          options={userTypes}
          paramsKey={"users-type"}
          filterType={userFilter}
        />
      </CustomMenu>
    </div>
  );
}

export default React.memo(FilterUserType);
